import { Banner } from 'components/Banner/Banner'
import useRouter from 'hooks/useRouter'

interface IProps {
  className?: string
}

export const NoCategoriesWarning = ({ className }: IProps) => {
  const router = useRouter()
  return (
    <Banner.Warning
      text="No contract categories available. Please make sure contract categories are set up."
      className={className}
      button={[
        {
          buttonText: 'Go to category setup',
          onButtonClick: () => {
            router.push('/contracts/contract_categories/new')
          }
        }
      ]}
    />
  )
}
